import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface Buzz {
  table: string;
  reason: string;
  timestamp: Date;
  orderId?: string;
}

@Injectable({
  providedIn: 'root'
})
export class BuzzService {
  private buzzes: Buzz[] = [];
  private buzzesSubject = new BehaviorSubject<Buzz[]>([]);

  constructor() {
    // Load any saved buzzes from localStorage on service initialization
    const savedBuzzes = localStorage.getItem('activeBuzzes');
    if (savedBuzzes) {
      this.buzzes = JSON.parse(savedBuzzes).map((buzz: any) => ({
        ...buzz,
        timestamp: new Date(buzz.timestamp)
      }));
      this.buzzesSubject.next(this.buzzes);
    }
  }

  addBuzz(buzz: Buzz) {
    this.buzzes.unshift(buzz);
    this.updateBuzzes();
  }

  clearBuzz(index: number) {
    this.buzzes.splice(index, 1);
    this.updateBuzzes();
  }

  getBuzzes() {
    return this.buzzesSubject.asObservable();
  }

  private updateBuzzes() {
    this.buzzesSubject.next(this.buzzes);
    // Save to localStorage for persistence
    localStorage.setItem('activeBuzzes', JSON.stringify(this.buzzes));
  }

  clearAllBuzzes() {
    this.buzzes = [];
    this.updateBuzzes();
  }

  clearExpiredBuzzes(expirationMinutes: number = 60) {
    const now = new Date();
    this.buzzes = this.buzzes.filter(buzz => {
      const diffMinutes = (now.getTime() - new Date(buzz.timestamp).getTime()) / 60000;
      return diffMinutes < expirationMinutes;
    });
    this.updateBuzzes();
  }
} 